import React from 'react';
import { Link } from 'react-router-dom';

import Icon from 'components/Icon';

import { Spinner } from 'styles/common';
import { StyledButton, StyledLink } from './style';

const Button = ({
	'aria-label': ariaLabel,
	tag: Tag = 'button',
	color = 'primary',
	innerRef,
	disabled,
	loading,
	children,
	href,
	block,
	size,
	outline,
	noHover,
	selected,
	link,
	icon,
	to,
	onClick = () => {},
	onDisable = () => {},
	...attrs
}) => {
	const onClickHandler = (e) => {
		if (loading) {
			e.preventDefault();
			return;
		}

		if (disabled) {
			onDisable(e);
		} else {
			onClick(e);
		}
	};

	if (href) {
		attrs.as = 'a';
		attrs.href = href;
	}

	// share size attribute to Icon component
	if (typeof children !== 'string' && children.length > 0) {
		children = children.map((child) => {
			if (child.type && child.type.name === Icon.name) {
				return { ...child, props: { size, ...child.props } };
			}
			return child;
		});
	} else if (children.type && children.type.name === Icon.name) {
		children = { ...children, props: { size, ...children.props } };
	}

	const fields = {
		ref: innerRef,
		onClick: onClickHandler,
		'aria-label': ariaLabel,
		$disabled: disabled,
		$block: block,
		$color: color,
		$size: size,
		$outline: outline,
		$nohover: noHover,
		$link: link,
		$selected: selected,
		$loading: loading,
		...attrs,
	};

	return to ? (
		<StyledLink {...fields}>
			<Link to={to}>
				<span>
					{loading ? (
						<Spinner $color={color === 'primary' ? 'white' : color} />
					) : (
						<>
							{icon && <Icon className='ml' name={icon} />}
							{children}
						</>
					)}
				</span>
			</Link>
		</StyledLink>
	) : (
		<StyledButton
			type={Tag === 'button' && attrs.onClick ? 'button' : undefined}
			{...fields}
		>
			<span>
				{loading ? (
					<Spinner $color={color === 'primary' ? 'white' : color} />
				) : (
					<>
						{icon && <Icon className='ml' name={icon} />}
						{children}
					</>
				)}
			</span>
		</StyledButton>
	);
};

export default Button;
